var T = "none", E = "appear", r = "enter", a = "leave", S = "none", e = "prepare", A = "start", v = "active", P = "end", _ = "prepared";
export {
  E as STATUS_APPEAR,
  r as STATUS_ENTER,
  a as STATUS_LEAVE,
  T as STATUS_NONE,
  P as STEP_ACTIVATED,
  v as STEP_ACTIVE,
  S as STEP_NONE,
  e as STEP_PREPARE,
  _ as STEP_PREPARED,
  A as STEP_START
};
//# sourceMappingURL=interface.mjs.map
